
import { ref, SetupContext } from "vue";
import { BaseInput } from "components/atoms";

type OptionType = {
  key: string;
  label: string;
};

interface DropdownProps {
  options: OptionType[];
  placeholder?: string;
  modelValue: string[];
  optionLabel?: string;
  optionValue?: string;
  validationStatus: object;
}

export default {
  name: "MultiDropdown",
  components: { BaseInput },
  props: {
    value: {
      required: true,
      type: Array as () => string[],
    },
    options: {
      required: true,
      type: Array as () => OptionType[],
    },
    placeholder: {
      required: false,
      type: String,
      default: "Click here to select",
    },
    modelValue: {
      type: Array as () => string[],
      required: true,
    },
    optionLabel: {
      required: false,
      type: String,
      default: "label",
    },
    optionValue: {
      required: false,
      type: String,
      default: "value",
    },
    validationStatus: {
      type: Object,
      required: true,
    },
  },
  setup(props: DropdownProps, { emit }: SetupContext) {
    const isOptionsWrapperToggled = ref(false);
    const selectedItems = ref([] as OptionType[]);

    /**
     * Toggle/Untoggle the main option wrapper
     */
    const toggleOptions = () => {
      isOptionsWrapperToggled.value = !isOptionsWrapperToggled.value;
    };

    /**
     * Close the option dialog on outside click
     */
    const closeOptions = () => (isOptionsWrapperToggled.value = false);

    /**
     * Return the option index in the selected list
     */
    const getOptionIndex = (option: OptionType) => {
      return selectedItems.value.findIndex(
        (selectedOption: OptionType) => selectedOption.key === option.key
      );
    };

    /**
     * Return the state of a specific option (boolean)
     */
    const isOptionSelected = (option: OptionType) => {
      return getOptionIndex(option) !== -1;
    };

    /**
     * Handle the selection/unselection action on the selectedItems array
     */
    const selectOption = (option: OptionType) => {
      const index = getOptionIndex(option);
      if (index === -1) {
        // Push new entry to the selection array
        selectedItems.value.push(option);
      } else {
        // Remove item from selected array
        selectedItems.value.splice(index, 1);
      }

      // Emit update event
      emit("update:modelValue", selectedItems.value);
    };

    return {
      isOptionsWrapperToggled,
      isOptionSelected,
      toggleOptions,
      selectOption,
      emit,
      selectedItems,
      closeOptions,
    };
  },
  emits: ["update:modelValue"],
};
